import script from "./ManageFundsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageFundsModal.vue?vue&type=script&setup=true&lang=js"

import "./ManageFundsModal.vue?vue&type=style&index=0&id=7631fbb0&lang=scss"

const __exports__ = script;

export default __exports__